const KEY = "praesto.ui.subSidebar";

export function getSubSidebarCollapsed(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(KEY) === "collapsed";
}

export function setSubSidebarCollapsed(c: boolean): void {
  localStorage.setItem(KEY, c ? "collapsed" : "expanded");
  window.dispatchEvent(new Event("praesto:sidebar-toggle"));
}

export function toggleSubSidebar(): void {
  setSubSidebarCollapsed(!getSubSidebarCollapsed());
}
